import React from 'react';

import { useTranslation } from 'react-i18next';
import { connectRefinementList } from 'react-instantsearch-dom';

import { CustomAccordion } from '../../../../components/CustomAccordion';
import { DURATION_FILTER, DURATION_FILTER_ORDER } from '../../const';
import { FilterItem } from '../FilterItem';
import { SearchInput } from '../SearchInput';
import ShowMoreBtn from './ShowMoreBtn';
import useStyles from './style';

export const RefinementList = ({
  items,
  refine,
  showMore,
  limit,
  searchForItems,
  attribute,
  searchable,
  delay = 0,
  hidden = false,
  isFromSearch,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const itemsToShow = showMore && limit ? limit : items.length;

  const filtersToShow =
    attribute !== DURATION_FILTER
      ? items
      : items.sort((a, b) => {
          const aIndex = DURATION_FILTER_ORDER.indexOf(a?.label);
          const bIndex = DURATION_FILTER_ORDER.indexOf(b?.label);
          return (a.isRefined && aIndex - bIndex) || b.isRefined || aIndex - bIndex;
        });

  return !hidden ? (
    <>
      {searchable && <SearchInput handleSearch={searchForItems} isFromSearch={isFromSearch} />}
      {filtersToShow && filtersToShow.length > 0 ? (
        showMore ? (
          <CustomAccordion itemsToShow={itemsToShow} ButtonComponent={ShowMoreBtn} delay={delay}>
            {filtersToShow.map((item) => (
              <FilterItem
                key={item.label}
                label={item.label}
                value={item.value}
                refine={refine}
                isRefined={item.isRefined}
                count={item.count}
                filterValue={attribute}
              />
            ))}
          </CustomAccordion>
        ) : (
          filtersToShow.map((item) => (
            <FilterItem
              key={item.label}
              label={item.label}
              value={item.value}
              refine={refine}
              isRefined={item.isRefined}
              count={item.count}
              filterValue={attribute}
            />
          ))
        )
      ) : (
        <div className={classes.noItems}>{t('page.discover.noFiltersAvailable')}</div>
      )}
    </>
  ) : (
    <></>
  );
};

export default connectRefinementList(RefinementList);
